mutation PublishVariationsXmlFeed(
    $campaignId: ID!
    $publishProvider: String!
    $computedDeliverableIdentifiers: [InputComputedDeliverableIdentifier]
    $libraryFilters: InputLibraryFilters
    $isRendering: Boolean
    $rebuild: Boolean
) {
    publishVariationsXmlFeed(
        campaignId: $campaignId
        publishProvider: $publishProvider
        computedDeliverableIdentifiers: $computedDeliverableIdentifiers
        libraryFilters: $libraryFilters
        isRendering: $isRendering
        rebuild: $rebuild
    )
}
